import '../../../src/styles/healthInfo.css';
import Table from '../../generic_components/Table/Table';

const OfflineServersPastWeek = ( {servers} ) => {
  
  const offlineServersPastWeek_columns = [
    { key: 'business', label: 'Business' },
    { key: 'siteName', label: 'Site name' },
    { key: 'serverName', label: 'Server name' },
  ];

  const offlineServersPastWeek_data = servers.map((server, index) => (
    {
      business: server.business,
      siteName: server.site,
      serverName: server.serverName
    }
  ));


  return (   
      <div className='table-container-device' style={{ fontSize: '.85em' }}>        
          <Table
            columns = {offlineServersPastWeek_columns}
            data = {offlineServersPastWeek_data}
          />
      </div>

    
  )
}

export default OfflineServersPastWeek;